import { observer } from 'mobx-react';
import React, { PropsWithChildren } from 'react';
import useAnalytics from '../../../../../common/useAnalytics';
import { AnalyticsEvents } from '../../../../../services/analytics/analytics-events';
import {
    TemplatesListItemContainer,
    TemplatesListItemProps
} from '../StepSideBar/StepSideBar.styles';
import { useRootStore } from '~/stores/useRootStore';

interface Props extends TemplatesListItemProps {
    isEmail?: boolean;
    onClick: () => void;
    className?: string;
}

const TemplatesListItemWrapper = ({
    onClick,
    children,
    isEmail,
    ...props
}: PropsWithChildren<Props>) => {
    const {
        automationUiStore: { selectedStep }
    } = useRootStore();

    const { track } = useAnalytics();

    const _onClick = () => {
        onClick();
        track(AnalyticsEvents.AutomationsSideBarActionTemplate, {
            action: 'click',
            type: isEmail ? 'email' : selectedStep?.combinedType
        });
    };

    return (
        <TemplatesListItemContainer {...props} onClick={_onClick}>
            {children}
        </TemplatesListItemContainer>
    );
};

export default observer(TemplatesListItemWrapper);
